import request from '@/utils/request'

export const postInsuranceCard = (
  medicalBusinessId: string,
  customerId: string,
  frontImage: File,
  backImage?: File
): Promise<boolean> => {
  const formData = new FormData()
  formData.append('front_image', frontImage)
  if (backImage) {
    formData.append('back_image', backImage)
  }
  return request({
    url: `/api/v0/customer/medical-customers/insurance-cards/${medicalBusinessId}/${customerId}/`,
    method: 'POST',
    data: formData
  })
    .then(() => true)
    .catch(error => {
      console.error(error)
      return false
    })
}
